import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useUserStore } from 'src/_store/user.store'
import { IOrder, ISupplierOrder } from 'src/_models/order.model'
import { useTranslation } from 'react-i18next'
import OrderDetailTables from 'src/pages/fuel-trading/order-detail-tables'
import { useSearchParams } from 'react-router-dom'

const FuelTradingOrdersCancelledPage = () => {
  const [orders, setOrders] = useState<IOrder[]>([])
  const [searchParams, _] = useSearchParams()

  const params = searchParams.toString()

  const cancelledOrdersQuery = useQuery({
    queryKey: ['orders', 'orders/cancelled', params],
    queryFn: () => {
      const token = localStorage.getItem('token')
      return axios.get<ISupplierOrder[]>(`/api/orders/cancelled?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    },
  })

  useEffect(() => {
    if (cancelledOrdersQuery.data) {
      setOrders(cancelledOrdersQuery.data.data)
    }
  }, [cancelledOrdersQuery.data])

  return (
    <>
      <section className="w-full">
        <OrderDetailTables heading="Cancelled Orders" orders={orders} />
      </section>
    </>
  )
}

export default FuelTradingOrdersCancelledPage
